import React,{useEffect} from 'react'
import "./popular.css"
import {BsArrowLeftShort, BsArrowRightShort, BsDot} from "react-icons/bs"
import {} from "react-icons/bs"

import Aos from 'aos';
import 'aos/dist/aos.css';

import img2 from '../../assets/london.jpg'
import img1 from '../../assets/marrakech.jpg'
import img3 from '../../assets/korea.jpg'
import img4 from '../../assets/rome.jpg'


const Data = [
  {
    id: 1,
    imgSrc: img1,
    destTitle: 'Marrakesh',
    location:  'Morocco',
    rating: 4.8,
    grade: 'HISTORICAL TRADITION',
  },
  {
    id: 2,
    imgSrc: img2,
    destTitle: 'London',
    location: 'United Kingdom',
    rating: 4.5,
    grade: 'CULTURAL CENTER',
  },
  {
    id: 3,
    imgSrc: img3,
    destTitle: 'Hanok',
    location: 'Korea',
    rating: 4.2,
    grade: 'NATURE LOVER',
  },
  {
    id: 4,
    imgSrc: img4,
    destTitle: 'Rome',
    location:  'Italy',
    rating: 3.9,
    grade: 'ART AND HISTORY',
  },
]

const Popular = () => {

  useEffect(()=>{
    Aos.init({duration:2000});
  },[])


  return (
    <div id='Popular'>
      <section className="popular section container">
        <div className="secContainer">
          <div className="secHeader flex">
            <div data-aos="fade-right" data-aos-duration="2500" className="textDiv">
              <h2 className="secTitle">Popular Destination</h2>
              <p>From historical cities to natural specteculars,come see the best of the world!</p>
            </div>
            <div data-aos="fade-left" data-aos-duration="2500" className="iconsDiv flex">
              <BsArrowLeftShort className='icon iconLeft'/>
              <BsArrowRightShort className='icon iconRight' />
            </div>
          </div>
          <div className="mainContent grid">
            {
              Data.map(({id,imgSrc,destTitle,location,rating,grade})=>{
                return(
                  <div data-aos="fade-up" className="singleDestination">
                    <div className="destImage">
                      <img src={imgSrc} alt="Image title" />
                      <div className="overlayInfo">
                        <h3>{destTitle}</h3>
                        <p>{grade}</p>
                        <BsArrowRightShort className='icon' />
                      </div>
                    </div>
                    <div className="destFooter">
                      <div className="number">
                        0{id}
                      </div>
                      <div className="destText flex">
                        <h6>{location}</h6>
                        <span className='flex'>
                          <span className="dot">
                            <BsDot className='icon'/>
                          </span>
                          {rating}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </section>
    </div>
  )
}

export default Popular